import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducers';
import { composeWithDevTools } from 'redux-devtools-extension';

export default function configureStore(initialState: any = {}) {
    return createStore(
        rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(thunk)),
    );
} 
// const store = createStore(reducer, composeWithDevTools(
//     applyMiddleware(...middleware),
//     // other store enhancers if any
//   ));